import { type ReactNode } from 'react';

import { ActionCableContext, consumer } from '@/context/action-cable-context';

export function ActionCableProvider({ children }: { children: ReactNode }) {
  return <ActionCableContext.Provider value={consumer}>{children}</ActionCableContext.Provider>;
}
